import { useJobServiceFetch } from '@src/fetchers';

interface JobEvent {
  step: string;
  jobId: string;
  variant?: string | null;
  campaign?: string | null;
}

export function useTrackJobEvent() {
  const { fetch } = useJobServiceFetch();
  return ({ step, jobId, campaign, variant }: JobEvent) => {
    fetch('caja-job-events', {
      body: JSON.stringify({
        step,
        jobId,
        campaign,
        variant
      }),
      method: 'POST',
      credentials: 'include'
    });
  };
}
